import { observer } from 'mobx-react-lite';
import React from 'react';
import { tacticMap } from '../../../../../../../classes/tactics/tacticKeys';
import { TradePlanData } from '../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../classes/tradePlan/tradePlanProvider';

type Props = {
  size: number;
  scaleY: (value: number) => number;
  portalRef: {
    current: any;
  };
};

export const DisplayPreTactics = observer(
  ({ size, scaleY, portalRef }: Props) => {
    const tradePlanForm: TradePlanData | null = useTradePlanFormStore() ?? null;
    if (!tradePlanForm) return null;
    // figure out if any of the SIMPLE chart tacts exist on tradeplan, if so, display them
    const arr = [];
    if (tradePlanForm.setup === 'BREAK' || tradePlanForm.setup === 'BOUNCE') {
      arr.push(tradePlanForm.setup);
    }
    if (tradePlanForm.entryTactics.CANDLE_BREAK) {
      arr.push('CANDLE_BREAK');
    }
    if (tradePlanForm.exitTactics.BREAK_PRICE) {
      arr.push('BREAK_PRICE');
    }

    return (
      <>
        {arr.map((tactic) => {
          const Component = tacticMap[tactic].simpleChartComponent;
          return (
            <Component
              key={tactic}
              size={size}
              scaleY={scaleY}
              portalRef={portalRef}
            />
          );
        })}
      </>
    );
  }
);
